export default [{
  path: '/admin/apply/institution/list',
  name: 'institutionList',
  component: () => import('@/views/apply/institution/list/index'),
  meta: {
    title: '企业管理',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/config',
  name: 'institutionConfig',
  component: () => import('@/views/apply/institution/config'),
  meta: {
    title: '基础配置',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/classify',
  name: 'institutionClassify',
  component: () => import('@/views/apply/institution/classify'),
  meta: {
    title: '企业分类',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/power',
  name: 'institutionPower',
  component: () => import('@/views/apply/institution/power/index'),
  meta: {
    title: '权限管理',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/account',
  name: 'institutionAccount',
  component: () => import('@/views/apply/institution/account/index'),
  meta: {
    title: '账号管理',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/scene/list',
  name: 'institutionScene',
  component: () => import('@/views/apply/institution/scene/index'),
  meta: {
    title: '场景管理',
    headType: 0,
    auth: true
  }
}, {
  path: '/admin/apply/institution/role/list',
  name: 'institutionRole',
  component: () => import('@/views/apply/institution/role/index'),
  meta: {
    title: '角色管理',
    headType: 0,
    auth: true
  }
}]



// WEBPACK FOOTER //
// ./src/router/apply/institution.js